import React, { useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pexios, toast, validate } from '../../utils/functions';
import { history } from '../../utils/variables';
import { setAccidentInfo, setRouterData } from '../../redux/actions';
import Modal from '../../components/master/Modal';
import CarInfo from '../../components/pages/userInfo/CarInfo';
import InsuranceInfo from '../../components/pages/userInfo/InsuranceInfo';
import DriverInfo from '../../components/pages/userInfo/DriverInfo';
import CrouckiInfo from '../../components/pages/userInfo/CrouckiInfo';
export default function UserInfo() {

    const {location, accidentInfo,insuranceCode} = useSelector(store => store);
    const {id,culpritToken} = useSelector(store => store.routerData);
    const {details,user_type,searchType,lossesData,insurance_type} = accidentInfo;
    const [step,setStep] = useState(0);
    const [btnLoading,setBtnLoading] = useState(false)
    // useEffect(() => {
    //     pexios('/api/v2/get_accident', 'post', {accident_id: id, type: 'culprit'})
    //         .then(res => {
    //             const accident = res.data.data;
    //             const {culprit = {}} = accident;
    //             const {car = {}, user = {}} = culprit;
    //             const {third = {}, body = {}} = car;
    //             delete user.attachments;
    //             delete user.avatar;
    //             delete car.third;
    //             delete car.body;
    //             delete culprit.car;
    //             delete culprit.user;
    //             delete accident.user;
    //             delete accident.culprit;
    //             const data = {...accident, ...culprit, ...car, ...user, third, body}
    //             setData(data);
    //         });
    // }, [id]);

    const [data, setData] = useState({
        car:{
        chassis_number: null,
        car_type_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        third: {
            insurance_number: null,
            insurance_company: null,
            insurance_start_date :null,
            insurance_expire_date:null,
            insurance_owner_name:null,
            insurance_owner_national_id:null
        },
        body : {
            insurance_number: null,
            insurance_company: null,
            insurance_start_date: null,
            insurance_expire_date:null,
            insurance_owner_name:null,
            insurance_owner_national_id:null
        },
        plate_type: 'car',
        plate_iran: null,
        plate_left: null,
        plate_center: null,
        plate_right: null,
        },
        //driver
        driver_national_id :null,
        driver_birth_date: null,
        driver_mobile:null,
        owner_national_id :null,
        owner_birth_date: null,
        owner_mobile:null,
        license_type_id : null,
        license_number: null,
        license_start_date:null,
        crash_time:null,
        owner_sheba_number: null,
        license_limitation_id: null,
        //croucki
        has_coroukie: false,
        coroukie_type:null,
        coroukie_agent:null,
        coroukie_agent_code:null,
        coroukie_serial:null,
        coroukie_serie:null
        
    });
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(true);

    useEffect(()=>{
        setData(prevState=>({...prevState,car:{...prevState.car,...details}}))
        setLoader(false)
    },[details])
    function changeData(value, name,type) {
        if(type) {
            if(type === 'car') 
            setData(prevState => ({
                ...prevState,
                [type]:{
                    ...prevState[type],
                    [name]: value
            }}));
            else
            setData(prevState => ({
                ...prevState,
                car:{
                    ...prevState.car,
                    [type]:{
                        ...prevState.car[type],
                        [name]: value,
                    }}
            }));
        }
        else {
        if(name === 'has_coroukie'&& !value)
            setData(prevState => ({
                ...prevState,
                [name]: value,
                coroukie_type:null,
                coroukie_agent:null,
                coroukie_agent_code:null,
                coroukie_serial:null,
                coroukie_serie:null
            }));
        else 
            setData(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    }
    
    function handleEditInfo (type) {
        // let error = ''
        // if(form && form.current) error= validate(form);
        // // if(form2 && form2.current && validate(form2)) error += `${error ? ',':''}`+ validate(form2)
        // // const error = validate(form);
        // if (error) {
        //     toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
        //     return;
        // }
        switch (type) {
            case 'car' :
                pexios(`api/update_car_info`, 'post', {...data.car})
                .then(()=> setStep(1))
                break;
            case 'insurance' :
                setBtnLoading(true)
                pexios(`api/update_insurance`, 'post', {...data.car})
                .then((res) => {
                    setData(prevState=>({...prevState,car:{...prevState.car,...res.data}}))
                    if(user_type === 'culprit') {
                        setStep(3)
                        setBtnLoading(false)
                    }
                    else addLosses(res.data)
                })
                .catch(()=>{
                    toast('خطا در ثبت اطلاعات','error')
                    setBtnLoading(false)
                })
                break;
            default : break;
        }
    }
    function submitAccident(form) {
        let error = ''
        if(form && form?.current) error= validate(form);
        if (error) {
            toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            return;
        }
        setBtnLoading(true)
            const updatedData = {
                insurance_type : insurance_type,
                // car:{
                //     ...data,
                //     // ...res.data
                // },
                ...data,
                lat: location.lat,
                lng: location.lng,
                user_token:culpritToken,
                insuranceCode:insuranceCode
            }
            // let sentData
            // if(culpritToken){
            //     sentData = {...updatedData,user_token:culpritToken}
            // }else{
            //     sentData = {...updatedData}
            // }
            pexios('api/create_accident','post',updatedData)
            .then((res)=>{
                dispatch(setRouterData({ id : res.data.id, type: 'accident',state: res.data?.status,insuranceCompanyId:insurance_type === 'body'? data?.car?.body?.insurance_company: data?.car?.third?.insurance_company}));
                dispatch(setAccidentInfo({ ...accidentInfo,has_coroukie:data.has_coroukie }));
                if(res.data.type === 'new_accident'){
                    history.push(`/user-images`)
                }else{
                    history.push(`/accident-report`);
                }
            })
            .catch(()=>{
                toast('خطا در ثبت پرونده','error')
                setBtnLoading(false)
            })
    }
    function addLosses (response) {
        setBtnLoading(true)
        const updatedData = {
            accident_id : id,
            insurance_type : insurance_type,
            // car:{
            //     ...data,
            //     // ...res.data
            // },
            ...data,
            car: {
                ...data.car,
                ...response
            },
            lat: location.lat,
            lng: location.lng,
            user: lossesData
        }
        pexios('/api/add_losses','post',updatedData)
        .then((res)=>{
            history.push(`/user-images?index=${res.data.loss_index}`)
        })
        .catch(()=>{
            toast('خطا در افزودن زیان دیده','error')
            setBtnLoading(false)
        })
    }

    return (
        <div className='content details'>
            {loader ?
                <Modal visible={loader}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                </Modal>
            :
            <>
            {step === 0 &&
                <CarInfo
                    data={data.car}
                    changeData={changeData}
                    handleEditInfo={handleEditInfo}
                />
            }
            {step === 1 &&
                <DriverInfo
                    data={data}
                    changeData={changeData}
                    changeStep={(stage)=>stage === 'prev'? setStep(0) :setStep(2)}
                />
            }
            {step === 2 &&
                <InsuranceInfo
                    data={data.car}
                    userType={user_type}
                    hasBodyInsurance={insurance_type === 'body'}
                    changeData={changeData}
                    handleEditInfo={handleEditInfo}
                    changeStep={()=> setStep(1)}
                    btnLoading={btnLoading}
                />
            }
            {step === 3 &&
                <CrouckiInfo
                    data={data}
                    changeData={changeData}
                    changeStep={(stage,form)=>stage === 'prev'? setStep(2) : submitAccident(form)}
                    btnLoading={btnLoading}
                />
            }
            </>
            }
            {/* <div className='row text-right' ref={form}> */}
                {/* <Input
                    label='شماره شاسی'
                    value={data.chassis_number}
                    required
                    onChange={value => changeData(value, 'chassis_number')}
                />
                <CarSelect
                    data={{
                        carType: data.car_type_id,
                        carBrand: data.car_brand_id,
                        carModel: data.car_model_id,
                    }}
                    required
                    onChange={(value, type) => changeData(value, type)}
                /> */}
                {/* <Input
                    label='شماره بیمه نامه ثالث'
                    value={data.third_insurance_number}
                    required
                    onChange={value => changeData(value, 'third_insurance_number')}
                />
                <SearchablePicker
                    label='شرکت بیمه نامه ثالث'
                    value={data.third_insurance_company}
                    data={insuranceCompanies}
                    titleKey='title'
                    valueKey='id'
                    rtl
                    required
                    onSelect={val => changeData(val, 'third_insurance_company')}
                /> */}
                {/* <div className='col-12'>
                    <label className='custom-checkbox mt20'>
                        <input type='checkbox' checked={hasBodyInsurance} onChange={(e) => setHasBodyInsurance(e.target.checked)} />
                        <span className='checkmark' />
                    </label>
                    <span className='mr35'>بیمه بدنه دارم</span>
                </div>
                {
                    hasBodyInsurance &&
                        <>
                            <Input
                                label='شماره بیمه نامه بدنه'
                                value={data.body_insurance_number}
                                required
                                onChange={value => changeData(value, 'body_insurance_number')}
                            />
                            <SearchablePicker
                                label='شرکت بیمه نامه بدنه'
                                value={data.body_insurance_company}
                                data={insuranceCompanies}
                                rtl
                                placeholder='شرکت بیمه نامه بدنه'
                                titleKey='title'
                                valueKey='id'
                                //required
                                onSelect={val => changeData(val, 'body_insurance_company')}
                            />
                         </> */}
                {/* } */}
                {/* <Plate
                    type={data.plate_type}
                    plate={{
                        plate_iran: data.plate_iran,
                        plate_left: data.plate_left,
                        plate_center: data.plate_center,
                        plate_right: data.plate_right,
                    }}
                    change={(value, name) => changeData(value, name)}
                /> */}
            {/* </div> */}
            {/* <UserDocs
                data={user}
            /> */}
            {/* <div className='mt20 pr5 pl5'>
                <button
                    className='btn btn-green btn-block btn-circle'
                    disabled={loader}
                    onClick={submit}
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/> :
                            'ثبت اطلاعات'
                    }
                </button>
            </div> */}
        </div>
        // <div className='content userCarInfo'>
        // <div className='d-flex swip-header fullWidth'>
        //     <span className={`glider ${step === 0 ? 'first': 'second'}`}/>
        //     <span className={`swip-option ${step === 0 ? 'active': ''}`} onClick={()=>setStep(0)}>تکمیل اطلاعات</span>
        //     <span className={`swip-option ${step === 1 ? 'active': ''}`} onClick={()=>setStep(1)}>استعلام اطلاعات</span>
        // </div>
        // <div className='swip-body'>
        //     {
        //         step === 1 ?
        //         <div className='content'>
        //             <div className='row text-right'>
        //             <Input 
        //                 label='کد ملی'
        //                 required
        //                 value={searchInfo.nationalId}
        //                 onChange={value => changeDataSearchInfo(value, 'nationalId')}
        //                 col={12}
        //             />
        //             </div>
        //             <div className='row text-right'>
        //             <Plate
        //                 type={searchInfo.plate_type}
        //                 plate={{
        //                     plate_iran: searchInfo.plate_iran,
        //                     plate_left: searchInfo.plate_left,
        //                     plate_center: searchInfo.plate_center,
        //                     plate_right: searchInfo.plate_right,
        //                 }}
        //                 required
        //                 // fixed={true}
        //                 change={(value, name) => changeDataSearchInfo(value, name)}
        //             />
        //             </div>
        //             <div className='mt25 pr5 pl5'>
        //                 <button
        //                     className='btn btn-green btn-block btn-circle'
        //                     disabled={searchLoader}
        //                     onClick={searchData}
        //                 >
        //                     {
        //                         searchLoader ?
        //                             <i className='fas fa-spinner fa-spin'/> :
        //                             'مرحله بعد'
        //                     }
        //                 </button>
        //             </div>
        //         </div>
        //         :
        //         <div className='content details'>
        //             <div className='row text-right' ref={form}>
        //                 <Input
        //                     label='شماره شاسی'
        //                     value={data.chassis_number}
        //                     required
        //                     onChange={value => changeData(value, 'chassis_number')}
        //                 />
        //                 <CarSelect
        //                     data={{
        //                         carType: data.car_type_id,
        //                         carBrand: data.car_brand_id,
        //                         carModel: data.car_model_id,
        //                     }}
        //                     required
        //                     onChange={(value, type) => changeData(value, type)}
        //                 />
        //                 <Input
        //                     label='شماره بیمه نامه ثالث'
        //                     value={data.third_insurance_number}
        //                     required
        //                     onChange={value => changeData(value, 'third_insurance_number')}
        //                 />
        //                 <SearchablePicker
        //                     label='شرکت بیمه نامه ثالث'
        //                     value={data.third_insurance_company}
        //                     data={insuranceCompanies}
        //                     titleKey='title'
        //                     valueKey='id'
        //                     rtl
        //                     required
        //                     onSelect={val => changeData(val, 'third_insurance_company')}
        //                 />
        //                 <div className='col-12'>
        //                     <label className='custom-checkbox mt20'>
        //                     {/* بیمه بدنه دارم */}
        //                         <input type='checkbox' checked={hasBodyInsurance} onChange={(e) => setHasBodyInsurance(e.target.checked)} />
        //                         <span className='checkmark' />
        //                     </label>
        //                     <span className='mr35'>بیمه بدنه دارم</span>
        //                 </div>
        //                 {
        //                     hasBodyInsurance &&
        //                         <>
        //                             <Input
        //                                 label='شماره بیمه نامه بدنه'
        //                                 value={data.body_insurance_number}
        //                                 required
        //                                 onChange={value => changeData(value, 'body_insurance_number')}
        //                             />
        //                             <SearchablePicker
        //                                 label='شرکت بیمه نامه بدنه'
        //                                 value={data.body_insurance_company}
        //                                 data={insuranceCompanies}
        //                                 rtl
        //                                 placeholder='شرکت بیمه نامه بدنه'
        //                                 titleKey='title'
        //                                 valueKey='id'
        //                                 required
        //                                 onSelect={val => changeData(val, 'body_insurance_company')}
        //                             />
        //                         </>
        //                 }
        //                 <Plate
        //                     type={data.plate_type}
        //                     plate={{
        //                         plate_iran: data.plate_iran,
        //                         plate_left: data.plate_left,
        //                         plate_center: data.plate_center,
        //                         plate_right: data.plate_right,
        //                     }}
        //                     change={(value, name) => changeData(value, name)}
        //                 />
        //             </div>
        //             <UserDocs
        //                 data={user}
        //             />
        //             <div className='mt20 pr5 pl5'>
        //                 <button
        //                     className='btn btn-green btn-block btn-circle'
        //                     disabled={loader}
        //                     onClick={submit}
        //                 >
        //                     {
        //                         loader ?
        //                             <i className='fas fa-spinner fa-spin'/> :
        //                             'تایید'
        //                     }
        //                 </button>
        //             </div>
        //         </div>
        //     }
        // </div>
        // </div>
    );
};
